<template>
  <div class="">
    <Navbar />

    <div id="main">
      <div class="container">
        <div id="cover" class="row align-items-center">
          <div id="top" class="col-lg-4 col-md-5 col-sm-12">
            <h2 style="color:#fff; text-shadow: 1px 20px 50px white;">VOICE CASTING</h2>
          </div>
          <div class="col-lg-8 col-md-7 col-12">
            <img src="/logo/casting.png" style="width:100%;margin-top:-10px;">
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div id="detail" style="min-height:200px; background: linear-gradient(#1b1b1b, #4e4e4e); color:#fff;">
            <div class="text-center mb-4">
              <h4>At IDIOM, we believe creativity and imagination are essential to the casting process.
              </h4>
            </div>
            <div class="text-center" style="line-height: 1.8em; align:justify;">
              <small>
                With experience across television, radio, animation, and promos, we provide access to a curated roster
                of union and non-union voice talent worldwide. Our offices in Los Angeles, Mumbai, Honolulu, and Phuket
                deliver seamless, expert casting services.
              </small>
              <br><br>
              <small>
                We maintain high industry standards and take a thoughtful, hands-on approach—from organizing auditions
                at no cost to managing talent scheduling and session logistics.
              </small>
              <br><br>
              <h6>
                For assistance with your next project, email <a
                  href="mailto:casting@idiomtalent.com">casting@idiomtalent.com.</a> with your script, specs,
                budget, and deadline.
              </h6>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>

  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Casting',
  components: { Navbar, Footer },
}
</script>

<style scoped>
/* #main { background-color:#aa4d8e !important; } */
#main {
  background-color: #894073 !important;
}

#cover {
  background: #050608 !important;
  height: 495px;
}

#top h2 {
  text-align: right;
}

#detail {
  padding: 50px;
}

#detail small {
  font-size: 16px;
}

@media (max-width: 600px) {
  #cover {
    min-height: 10px;
    max-height: 190px;
  }

  /* #top h2{ text-align:center; font-size:22px; } */
  #top {
    display: none;
  }

  #detail h4 {
    font-size: 18px;
  }

  #detail small {
    font-size: 14px;
  }

  #detail {
    padding: 25px;
  }
}
</style>
